/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * Platform API
 * The Platform API
 * OpenAPI spec version: 2.0
 */

export type SuspendCardResponseProductCardImageDetailsOneOfCardOrientation = typeof SuspendCardResponseProductCardImageDetailsOneOfCardOrientation[keyof typeof SuspendCardResponseProductCardImageDetailsOneOfCardOrientation];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SuspendCardResponseProductCardImageDetailsOneOfCardOrientation = {
  LANDSCAPE: 'LANDSCAPE',
  PORTRAIT: 'PORTRAIT',
} as const;
